import type {
  RightToInformationDocumentRow,
  RightToInformationWizardDraft,
} from '../types/rightToInformationCaseRequest';
import { FILE_CATEGORY_RIGHT_TO_INFORMATION } from '../pages/wizard/rightToInformation/rightToInformationConstants';
import { isDocumentTypeUuid } from '../utils/documentTypeId';

export const DEFAULT_RIGHT_TO_INFORMATION_DRAFT: RightToInformationWizardDraft = {
  fileCategory: FILE_CATEGORY_RIGHT_TO_INFORMATION,
  fileCategoryId: '',
  subFileCategoryId: '',
  subFileCategoryName: '',
  applicableAreas: [],
  applicableAreaIds: [],

  requestorName: '',
  nicOrPassportNumber: '',
  address: '',
  contactNumber: '',
  emailAddress: '',
  isSriLankanCitizen: 'no',
  specificPublicAuthorityName: '',
  requestedInformationDetails: '',
  informationRequestedTimePeriod: '',
  preferredMethodOfAccessIds: [],
  preferredMethodOfAccessNames: [],
  preferredLanguageId: '',
  preferredLanguageName: '',
  involvesLifeOrPersonalLiberty: 'no',
  justification: '',
  additionalNotes: '',

  urgencyLevelId: '',
  urgencyLevelName: '',
  deadline: '',
  urgencyJustification: '',

  submittedByUserId: '',
  submittedByDisplayName: '',
  submittedAgencyName: '',
  submittedDivisionName: '',
  submitterDesignation: '',
  submitterEmail: '',
  submitterContactNo: '',

  documents: [],
  confirmCorrect: false,

  draftRequestId: '',
  referenceNo: '',
};

export type RightToInformationWizardContextValue = {
  draft: RightToInformationWizardDraft;
  setDraft: React.Dispatch<React.SetStateAction<RightToInformationWizardDraft>>;
  reset: () => void;
};

function normalizeDocLabel(name: string): string {
  return name.trim().toLowerCase().replace(/\s+/g, ' ');
}

function findDocumentForChecklistItem(
  prev: RightToInformationDocumentRow[],
  item: { id: string; documentTypeId: string; name: string; documentTypeCode?: string },
): RightToInformationDocumentRow | undefined {
  return prev.find((d) => {
    if (d.checklistItemId === item.id) return true;
    if (item.documentTypeId && d.documentTypeId === item.documentTypeId) return true;
    if (item.documentTypeCode) {
      if (d.documentTypeId === item.documentTypeCode || d.checklistItemId === item.documentTypeCode) return true;
    }
    if (!isDocumentTypeUuid(d.documentTypeId) && normalizeDocLabel(d.documentName) === normalizeDocLabel(item.name)) {
      return true;
    }
    return false;
  });
}

export function syncRightToInformationDocumentsFromChecklist(
  prev: RightToInformationDocumentRow[],
  checklist: { id: string; documentTypeId: string; name: string; mandatory: boolean; documentTypeCode?: string }[],
): RightToInformationDocumentRow[] {
  return checklist.map((item) => {
    const existing = findDocumentForChecklistItem(prev, item);
    if (existing) {
      return {
        ...existing,
        checklistItemId: item.id,
        documentTypeId: item.documentTypeId,
        documentName: item.name,
        mandatory: item.mandatory,
      };
    }
    return {
      id: crypto.randomUUID(),
      checklistItemId: item.id,
      documentTypeId: item.documentTypeId,
      documentName: item.name,
      mandatory: item.mandatory,
      fileName: '',
      originalFileName: '',
      uploadTime: '',
      skipReason: '',
    };
  });
}
